import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconBookmarkFill = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="m10 14.552-3.308 1.42c-.502.214-.979.173-1.43-.124-.453-.297-.679-.715-.679-1.253V4.423c0-.42.146-.777.438-1.069a1.454 1.454 0 0 1 1.069-.437h7.82c.421 0 .777.146 1.07.437.29.292.437.648.437 1.07v10.17c0 .54-.226.957-.678 1.254-.452.297-.93.338-1.431.123L10 14.551Z"
      />
    </Svg>
  );
};

export default IconBookmarkFill;
